/**
 * 从后端响应中提取客户端 IP 字符串。
 * @param {unknown} data 接口 data 字段
 * @returns {string} IP 字符串，无法解析时返回空串
 */
const extractClientIp = (data) => {
  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }
  if (data && typeof data === "object") {
    const candidates = [data.ip, data.clientIp, data.client_ip, data.IP];
    for (let i = 0; i < candidates.length; i++) {
      const item = candidates[i];
      if (typeof item === "string" && item.trim()) {
        return item.trim();
      }
    }
  }
  return "";
};

/**
 * 获取当前请求的客户端 IP（由后端从请求中解析）。
 * 对齐 PC：GET /camel-gateway/gjmsAdmin/blackWord/getInfo
 * @returns {Promise<string>} 客户端 IP，失败时返回空串
 */
export const getClientIpInfo = async () => {
  try {
    const res = await fetch("/camel-gateway/gjmsAdmin/blackWord/getInfo");
    if (!res.ok) {
      throw new Error("HTTP " + res.status);
    }
    const result = await res.json();
    return extractClientIp(result && result.data != null ? result.data : result);
  } catch (error) {
    console.error("获取客户端 IP 失败:", error);
    return "";
  }
};
